// src/modules/gyms/models/gym.model.ts

export interface GymBrand {
  id: string;
  contractId: string;
  name: string;
  contactEmail: string;
  contactPhone: string;
  logo: string | null;
  banner: string | null;
  description: string;
  scan_record: string | null;
  showSocial: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface BranchImage {
  url: string;
  key: string;
  category?: string;
}

export interface GymBranch {
  id: string;
  brandId: string;
  name: string;
  address: string;
  lat: number | null;
  lng: number | null;
  operatingHoursFrom: string;
  operatingHoursTo: string;
  amenities: string[];
  description: string;
  ctaLink: string;
  images: BranchImage[];
  openingHours?: Record<string, { start_time: string; end_time: string }>;
  categories: string[];
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export type GymServiceUnitType = "SESSION" | "DAY" | "MONTH";

export type GymServiceCategory =
  | "GYM"
  | "YOGA"
  | "BOXING"
  | "PILATES"
  | "NUTRITION"
  | "RECOVERY"
  | "SPORTS"
  | "OTHERS";

export interface GymServiceImage {
  url: string;
  key: string;
}

export interface GymService {
  id: string;
  brandId: string;
  branchId: string;
  name: string;
  category: GymServiceCategory;
  price: number;
  amount: number;
  unitType: GymServiceUnitType;
  description: string;
  active: boolean;
  images: GymServiceImage[];
  expirationAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export const GYM_SERVICE_CATEGORIES: GymServiceCategory[] = [
  "GYM",
  "YOGA",
  "BOXING",
  "PILATES",
  "NUTRITION",
  "RECOVERY",
  "SPORTS",
  "OTHERS",
];

export const GYM_SERVICE_UNIT_TYPES: GymServiceUnitType[] = [
  "SESSION",
  "DAY",
  "MONTH",
];

export interface Amenity {
  id: string;
  label: string;
  icon?: string;
}

export enum CategoryImage {
  GYM = "GYM",
  YOGA = "YOGA",
  BOXING = "BOXING",
  SWIM = "SWIM",
  SAUNA = "SAUNA",
  REHAB = "REHAB",
  GROUP_X = "GROUP_X",
  CARDIO = "CARDIO",
  FUNCTIONAL = "FUNCTIONAL",
  FREE_WEIGHT = "FREE_WEIGHT",
  LOCKER = "LOCKER",
  PILATES = "PILATES",
  RECOVERY = "RECOVERY",
  OTHERS = "OTHERS",
}

export const AMENITIES_LIST: Amenity[] = [
  { id: "motorcycle_parking", label: "Motorbike parking" },
  { id: "car_parking", label: "Car parking" },
  { id: "locker", label: "Personal locker" },
  { id: "hot_cold_shower", label: "Hot/cold shower" },
  { id: "sauna", label: "Sauna room" },
  { id: "stretching_room", label: "Stretching room" },
  { id: "inbody", label: "Inbody body composition analyzer" },
  { id: "free_water", label: "Free drinking water" },
  { id: "free_towel", label: "Free workout towel" },
  { id: "open_24_7", label: "Open 24/7" },
  { id: "allow_freelancer", label: "Freelancer allowed" },
  { id: "other", label: "Other amenities" },
];
